import { render, staticRenderFns } from "./ClicDropdownItem.vue?vue&type=template&id=1ed77c7a&"
import script from "./ClicDropdownItem.vue?vue&type=script&lang=js&"
export * from "./ClicDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports